var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.274 5.859a2.801 2.801 0 012.538-1.61h30.379c1.09 0 2.075.626 2.539 1.61a2.819 2.819 0 01-.366 2.989L24.502 24.564v8.938c0 .851-.478 1.631-1.244 2.011a2.247 2.247 0 01-2.356-.21l-4.5-3.376c-.57-.422-.9-1.09-.9-1.8v-5.563L2.631 8.841a2.805 2.805 0 01-.358-2.982z"
  })));
}
export default SvgFilterSolid;